import React from 'react';
import { useNavigate } from 'react-router-dom';
import StitchLayout from '../../components/Crm/CrmLayout';

interface SimulatorCard {
    title: string;
    description: string;
    path: string;
}

const simulators: SimulatorCard[] = [
    {
        title: 'Sahara Call Simulator',
        description: 'Inbound WebRTC · Sahara AI',
        path: '/crm/sahara-webrtc-simulator',
    },
];

const AiCallSimulator: React.FC = () => {
    const navigate = useNavigate();

    return (
        <StitchLayout>
            <div style={{
                maxWidth: 400,
                margin: '72px auto',
                display: 'flex',
                flexDirection: 'column',
                gap: 24,
            }}>
                {/* Title block — matches Sahara simulator */}
                <div>
                    <h1 style={{ fontSize: 20, fontWeight: 700, color: '#111827', margin: 0, marginBottom: 4 }}>
                        AI Call Simulator
                    </h1>
                    <p style={{ fontSize: 13, color: '#9ca3af', margin: 0 }}>
                        Select a simulator to test AI-powered call flows.
                    </p>
                </div>

                {/* Cards — same border/radius as the simulator card */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {simulators.map((sim) => (
                        <button
                            key={sim.path}
                            onClick={() => navigate(sim.path)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '18px 20px',
                                background: '#fff',
                                border: '1px solid #e5e7eb',
                                borderRadius: 14,
                                cursor: 'pointer',
                                textAlign: 'left',
                                width: '100%',
                                transition: 'border-color 0.15s',
                            }}
                            onMouseEnter={e => {
                                (e.currentTarget as HTMLButtonElement).style.borderColor = '#7c3aed';
                            }}
                            onMouseLeave={e => {
                                (e.currentTarget as HTMLButtonElement).style.borderColor = '#e5e7eb';
                            }}
                        >
                            <div>
                                <div style={{ fontSize: 15, fontWeight: 600, color: '#111827', marginBottom: 3 }}>
                                    {sim.title}
                                </div>
                                <div style={{ fontSize: 13, color: '#9ca3af' }}>
                                    {sim.description}
                                </div>
                            </div>
                            <span style={{ fontSize: 16, color: '#d1d5db', marginLeft: 12 }}>›</span>
                        </button>
                    ))}
                </div>
            </div>
        </StitchLayout>
    );
};

export default AiCallSimulator;
